<template>
	<BaseButton
		class="flex items-center justify-center w-full h-40 whitespace-nowrap rounded text-strong-base"
		:class="active ? 'shadow bg-gray-500' : 'bg-gray-650 text-gray-400'"
		:disabled="active"
		@click="$emit('click')"
	>
		<BaseIcon v-if="tabName === 'media'" name="mono/media" />
		<BaseIcon v-else-if="tabName === 'dev-tools'" name="mono/devtools" />
		<BaseIcon v-else-if="tabName === 'details'" name="mono/info" />
		<slot />
	</BaseButton>
</template>

<script>
export default {
	name: 'SessionContentMobileTabButton',
	props: {
		tabName: {type: String, required: true, validator: v => ['media', 'dev-tools', 'details'].includes(v)},
		active: Boolean,
	},
	emits: ['click'],
}
</script>
